import { Routes, Route } from "react-router-dom";
import GeoJSON from '../GeoJson/GeoJson';
import SimFix from '../pages/Simfix';
import Analysis from "../pages/Analysis";
import SignalFix from '../signal_fix';
import AssignxPage from '../features/assignx';
import MysteryClient from '../pages/MysteryClient';

function Router() {
  return (
    <Routes>
      <Route path="/" element={<GeoJSON />} />
      <Route path="/simfix" element={<SimFix />} />
      <Route path="/analysis" element={<Analysis />} />
      <Route path="/signal-fix" element={<SignalFix />} />
      <Route path="/assignx" element={<AssignxPage />} />
      <Route path="/mystery-client" element={<MysteryClient />} />
    </Routes>
  )
}

export default Router